export const APP_NAME = 'backlot-front';

export const API_SERVER = 'https://stage.api.totus.pro/backlot/v1/';

export const AWS_LOCATION = 'ap-northeast-2';

// Development
export const MINGLO_GOOGLE_ID = '730009445982-7bki14gufevqsjttcpusiob0bobiloh6.apps.googleusercontent.com';
